import { BRAND } from '../config/brands';

// Brandbar — wordmark + bordered tag, driven by the active deployment's brand
// (one codebase, multiple branded deployments). Logo falls back to the name.
export default function Brandbar() {
  return (
    <div className="brandbar">
      <img
        src={BRAND.logoSrc}
        alt={BRAND.name}
        onError={(e) => {
          e.currentTarget.outerHTML =
            `<strong style="color:#fff;letter-spacing:.04em">${BRAND.name}</strong>`;
        }}
      />
      <span className="tag">{BRAND.tag}</span>
    </div>
  );
}
